import { actions as baseActions } from "../../../components/tree-view-actions/standart-actions";
import { statusActions } from "../../../components/tree-view-actions/status-actions";

export const actions = [
  ...statusActions,
  ...baseActions,
]
